/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 3.15.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateClientAsAdmin201Response,
  CreateClientAsAdminRequest,
  ExecuteGraphRequest200Response,
  ExecuteGraphRequestRequest,
  SetDatabaseChange200Response,
  SetDatabaseChange401Response,
  SetDatabaseChange500Response,
  UpdateUser400Response,
} from '../models/index';
import {
    CreateClientAsAdmin201ResponseFromJSON,
    CreateClientAsAdmin201ResponseToJSON,
    CreateClientAsAdminRequestFromJSON,
    CreateClientAsAdminRequestToJSON,
    ExecuteGraphRequest200ResponseFromJSON,
    ExecuteGraphRequest200ResponseToJSON,
    ExecuteGraphRequestRequestFromJSON,
    ExecuteGraphRequestRequestToJSON,
    SetDatabaseChange200ResponseFromJSON,
    SetDatabaseChange200ResponseToJSON,
    SetDatabaseChange401ResponseFromJSON,
    SetDatabaseChange401ResponseToJSON,
    SetDatabaseChange500ResponseFromJSON,
    SetDatabaseChange500ResponseToJSON,
    UpdateUser400ResponseFromJSON,
    UpdateUser400ResponseToJSON,
} from '../models/index';

export interface CreateClientAsAdminOperationRequest {
    createClientAsAdminRequest: CreateClientAsAdminRequest;
}

export interface ExecuteGraphRequestOperationRequest {
    executeGraphRequestRequest?: ExecuteGraphRequestRequest;
}

export interface RescanIoesRequest {
    clientUUID: string;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Create a new client
     */
    async createClientAsAdminRaw(requestParameters: CreateClientAsAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        if (requestParameters['createClientAsAdminRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientAsAdminRequest',
                'Required parameter "createClientAsAdminRequest" was null or undefined when calling createClientAsAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/client/new`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientAsAdminRequestToJSON(requestParameters['createClientAsAdminRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new client
     */
    async createClientAsAdmin(createClientAsAdminRequest: CreateClientAsAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.createClientAsAdminRaw({ createClientAsAdminRequest: createClientAsAdminRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Execute a graph request
     */
    async executeGraphRequestRaw(requestParameters: ExecuteGraphRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteGraphRequest200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/graph-explorer/request`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExecuteGraphRequestRequestToJSON(requestParameters['executeGraphRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteGraphRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Execute a graph request
     */
    async executeGraphRequest(executeGraphRequestRequest?: ExecuteGraphRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteGraphRequest200Response> {
        const response = await this.executeGraphRequestRaw({ executeGraphRequestRequest: executeGraphRequestRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Rescan all IOEs for this clients
     */
    async rescanIoesRaw(requestParameters: RescanIoesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDatabaseChange200Response>> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling rescanIoes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/client/{clientUUID}/audit/rescan`;
        urlPath = urlPath.replace(`{${"clientUUID"}}`, encodeURIComponent(String(requestParameters['clientUUID'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDatabaseChange200ResponseFromJSON(jsonValue));
    }

    /**
     * Rescan all IOEs for this clients
     */
    async rescanIoes(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDatabaseChange200Response> {
        const response = await this.rescanIoesRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

}
